export default "__VITE_ASSET__CoW3ysKn__"